import React, { Component, Fragment } from 'react'
import { FormGroup, ControlLabel, FormControl, Image, Row, Col } from 'react-bootstrap'
import { Field, ErrorMessage } from 'formik'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

class OrgDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showHint: false,
      mailHint: false,
      voidHint: false,
      IDHint: false,
    }
  } 
  

  render() {
    const { disabled, EF1, setFieldValue, uploadFile } = this.props
    return (
      <div>
            <h3>
              <img src={EF1 ? "3.png" : "3.png"} alt="no. step" className="num-icon half"/>
              { EF1 ? 'Business Information' : 'Sports Club Details'}
              </h3>
        <Row className="enrolment-row">
          {
            EF1 &&
            <Col sm={3}>
            <FormGroup>
              <ControlLabel>
                Legal Name
                </ControlLabel>
              <Field name="business_name" className="opaque-grey form-control" disabled={disabled}/>
              <ErrorMessage component="div" name="business_name" className="invalid-feedback"/>
            </FormGroup>
          </Col>
          }
          <Col sm={3}>
            <FormGroup>
              <ControlLabel style={{display: 'inline-block'}}>{ EF1 ? 'Operating Name' : 'Sports Club Name'}</ControlLabel>
              { EF1 ? "" :
                <a className="hint-tip" onClick={() => this.setState({ showHint: !this.state.showHint })}>
                  <FontAwesomeIcon icon={faInfoCircle} color='white'/>
                  {
                    this.state.showHint ?
                  <div className="hint-tip-text" id="name-hint">
                    <span>If your team doesn't play for a club use your team name.</span>
                  </div>
                  : ''
                  }
                </a>
              }
              <Field name="org_name" id="org_name" className="opaque-grey form-control" disabled={disabled}/>
              <ErrorMessage component="div" name="org_name" className="invalid-feedback"/>
            </FormGroup>
          </Col>
          <Col sm={2}>
            <FormGroup>
              <ControlLabel>Website Url</ControlLabel>
              <Field name="org_website" id="org_website" className="opaque-grey form-control" disabled={disabled}/>
              <ErrorMessage component="div" name="org_website" className="invalid-feedback"/>
            </FormGroup>
          </Col>
          {
            EF1 ? 
            <>
              <Col sm={2}>
                <FormGroup>
                  <ControlLabel>Contact Phone</ControlLabel>
                  <Field name="org_phone" className="opaque-grey form-control" disabled={disabled} />
                  <ErrorMessage component="div" name="org_phone" className="invalid-feedback"/>
                </FormGroup>
              </Col>
              <Col sm={2}>
                <FormGroup>
                  <ControlLabel>Contact Email</ControlLabel>
                  <Field name="org_email" className="opaque-grey form-control" disabled={disabled} />
                  <ErrorMessage component="div" name="org_email" className="invalid-feedback"/>
                </FormGroup>
              </Col> 
            </>
            :
            <>
              {/* <Col sm={2}>
                <FormGroup>
                  <ControlLabel>Instagram</ControlLabel>
                    <div className="hardcode-div">
                      <span className="hardcode-field opaque-grey form-control" id="inputGroup-sizing-default">@
                      <Field name="org_instagram" id="orgInstagram" className="hrdcode-field" disabled={disabled} placeholder="">
                      </Field>
                      </span>
                    </div>
                </FormGroup>
              </Col>
              <Col sm={2}>
                <FormGroup>
                  <ControlLabel>Other Social</ControlLabel>
                  <Field name="org_social" id="org_social" className="opaque-grey form-control" disabled={disabled} />
                </FormGroup>
              </Col> */}
            </>
          }
        </Row>
        { EF1 &&
        <>
          <Row className="enrolment-row">
            <Col sm={3}>
              <FormGroup>
                <ControlLabel style={{display: 'inline-block'}}>Legal Address</ControlLabel>
                <Field name="org_address" className="opaque-grey form-control" disabled={disabled}/>
                <ErrorMessage component="div" name="org_address" className="invalid-feedback"/>
              </FormGroup>
            </Col>
            <Col sm={3}>
              <FormGroup>
                <ControlLabel>City</ControlLabel>
                <Field name="org_city" className="opaque-grey form-control" disabled={disabled}/>
                <ErrorMessage component="div" name="org_city" className="invalid-feedback"/>
              </FormGroup>
            </Col>
            <Col sm={2}>
              <ControlLabel>Country</ControlLabel>
              <Field name="org_country" className="opaque-grey form-control" disabled={disabled}/>
              <ErrorMessage component="div" name="org_country" className="invalid-feedback"/>
            </Col>
            <Col sm={2}>
              <FormGroup>
                <ControlLabel>Province/State</ControlLabel>
                <Field name="org_province" className="opaque-grey form-control"disabled={disabled}/>
                <ErrorMessage component="div" name="org_province" className="invalid-feedback"/>
              </FormGroup>
            </Col>
            <Col sm={2}>
              <FormGroup>
                <ControlLabel>Postal/Zip Code</ControlLabel>
                <Field name="org_postal" className="opaque-grey form-control" disabled={disabled}/>
                <ErrorMessage component="div" name="org_postal" className="invalid-feedback"/>
              </FormGroup>
            </Col>
          </Row>
        </>
        }
          {
            EF1 &&
            <>
            <Row className="enrolment-row">
             <Col sm={3}>
                <FormGroup>
                  <ControlLabel style={{display: 'inline-block'}}>Business Type</ControlLabel>
                  <FormControl className="opaque-grey" name="business_type" componentClass="select" disabled={disabled} defaultValue={""} onChange={val => setFieldValue('business_type', val.target.value)}>
                    {busType}
                  </FormControl>
                  <ErrorMessage component="div" name="business_type" className="invalid-feedback"/>
                </FormGroup>
              </Col>
              <Col sm={3}>
                <FormGroup>
                  <ControlLabel style={{display: 'inline-block'}}>Business Number</ControlLabel>
                  <a className="hint-tip" onClick={() => this.setState({ busNoHint: !this.state.busNoHint })}>
                    <FontAwesomeIcon icon={faInfoCircle} color='white'/>
                    {
                      this.state.busNoHint ?
                    <div className="hint-tip-text" id="payment-hint">
                      <span> If your Business Number, GST Number, or Tax ID Number are unavailable you may enter your SIN/SSN</span>
                    </div>
                    : ''
                    }
                  </a>
                  <Field name="business_no" className="opaque-grey form-control" disabled={disabled}/>
                  <ErrorMessage component="div" name="business_no" className="invalid-feedback"/>
                </FormGroup>
              </Col>
              <Col sm={2}>
                <FormGroup>
                  <ControlLabel style={{display: 'inline-block'}}>Year Established</ControlLabel>
                  <Field name="yr_est" className="opaque-grey form-control" disabled={disabled}/>
                  <ErrorMessage component="div" name="yr_est" className="invalid-feedback"/>
                </FormGroup>
              </Col>
              <Col sm={2}>
                <FormGroup>
                  <ControlLabel>Void Check
                    <a className="hint-tip" onClick={() => this.setState({ voidHint: !this.state.voidHint })}>
                      <FontAwesomeIcon icon={faInfoCircle} color='white'/>
                      {
                        this.state.voidHint ?
                      <div className="hint-tip-text" id="payment-hint">
                        <span>This account will be used for deposits and billing</span>
                      </div>
                      : ''
                      }
                    </a>
                  </ControlLabel>
                  <FormControl id="upload_check" type="file" onChange={() => uploadFile('upload_check', setFieldValue)} ref={(ref) => { this.uploadInput = ref}}   disabled={disabled}/>
                  <ErrorMessage component="div" name="upload_check" className="invalid-feedback"/>
                </FormGroup>
              </Col>
              <Col sm={2}>
                <FormGroup>
                <ControlLabel>Identification
                <a className="hint-tip" onClick={() => this.setState({ IDHint: !this.state.IDHint })}>
                      <FontAwesomeIcon icon={faInfoCircle} color='white'/>
                      {
                        this.state.IDHint ?
                      <div className="hint-tip-text" id="payment-hint">
                        <span>Your ID should be valid and government issued.</span>
                      </div>
                      : ''
                      }
                    </a>
                </ControlLabel>
                  <FormControl id="upload_id" type="file" onChange={() => uploadFile('upload_id', setFieldValue)} ref={(ref) => { this.uploadInput = ref}} disabled={disabled} />
                  <ErrorMessage component="div" name="upload_id" className="invalid-feedback"/>
                </FormGroup>
              </Col>
            </Row>              
            </>
          }
      </div>
    )
  }
}
export default OrgDetails

const busType = [
  <option value="" key="0" disabled>---</option>,
  <option value="corporation" key="corporation">Corporation</option>,
  <option value="proprietorship" key="proprietorship">Sole Proprietorship</option>,
  <option value="partnership" key="partnership">Partnership</option>,
  <option value="non-profit" key="non-profit">Non-Profit</option>,
  <option value="tax-exempt" key="tax-exempt">Tax Exempt Organization</option>,
  <option value="llc" key="llc">Limited Liability Company</option>,
  <option value="other" key="other">Other</option>,
]